import React, {useState, useEffect } from "react";
import "./App.css";
import Footer from "./layout/components/footer/footer";
import Navbar from "./layout/components/navbar/navbar";
import Homepage from "./layout/pages/homepage/homepage";
import { Switch, Route, useLocation } from "react-router-dom";
import Blog from "./layout/pages/blog/blog";
import Blogcontent from "./layout/pages/blogContent/blogcontent";
import AboutUs from "./layout/pages/aboutUs/aboutUs";
import Projects from "./layout/pages/projects/projects";
import Contact from "./layout/components/contact/contact";
import Tmc from './layout/pages/tmc/tmc';
import Privacy from './layout/pages/privacy/privacy';


function App() {
  const [contact, setContact] = useState(false);
  const [windowOffSet, setWindowOffSet] = useState(0);
  const location = useLocation();
  useEffect(() => {
    if (contact) {
      setWindowOffSet(window.scrollY);
      document.body.setAttribute(
        "style",
        `position: fixed; top: -${windowOffSet}px; left: 0; right: 0;`
      );
    } else {
        document.body.setAttribute("style", "");
        window.scrollTo(0, windowOffSet);
    }
  }, [contact])

  return (
    <div className="App">
      <Navbar
        location={location}
        handleContact={() => setContact(true)}
      />
      <Switch location={location} key={location.pathname}>
        <Route exact path="/" render={(props) => <Homepage handleContact={() => setContact(true)} {...props}/>}/>
        <Route exact path="/blog" component={Blog} />
        <Route exact path="/blog/:id" component={Blogcontent} />
        <Route exact path="/aboutus" component={AboutUs} />
        <Route exact path="/term-and-conditions" component={Tmc} />
        <Route exact path="/privacy-policy" component={Privacy} />

        <Route exact path="/projects" component={Projects} />
      </Switch>
      <Footer />
      {contact ? (
          <Contact
          close={() => setContact(false)}
          />
        ) : null}
    </div>
  );
}

export default App;
